import { createApp } from 'vue'
import ElementPlus, { ElMessage, ElMessageBox, ElNotification } from 'element-plus'
// import 'element-plus/dist/index.css'
import 'jybf-ui/dist/style.css'

import { createPinia } from 'pinia'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { JyHeading as Heading } from 'jybf-ui'
import router from './router'

// 按需引入 element-plus 时，需要额外再引入全局的 $message 方法

// import './icons'

import 'default-passive-events'

import App from './App.vue'
import TrimSpaces from '@/directives/trim-spaces'
import JyDrawer from './components/jy-drawer/index.vue'
// import Heading from '@/components/heading/index.vue'
import ContentLayout from '@/components/content-layout/index.vue'
import JyTable from '@/components/jy-table/index.vue'
import SvgIcon from '@/components/svg-icon/index.vue'
import OperationZone from '@/components/operation-zone/index.vue'
import SearchBox from '@/components/search-box/index.vue'
import AutoHeight from '@/directives/auto-height/index.ts'
import NumberFixed from '@/directives/number-fixed/index.ts'
import Authorize from '@/directives/authorize/index.ts'
import './assets/styles/common.scss'
import 'element-plus/theme-chalk/el-message.css'
import 'element-plus/theme-chalk/el-message-box.css'
import 'element-plus/theme-chalk/el-notification.css'
import 'element-plus/theme-chalk/el-tree.css'
import './assets/styles/main.scss'
const app = createApp(App)

const properties: {
  [k: string]: unknown;
} = {
  $msgbox: ElMessageBox,
  $alert: ElMessageBox.alert,
  $confirm: ElMessageBox.confirm,
  $prompt: ElMessageBox.prompt,
  $message: ElMessage,
  $notify: ElNotification,
  $ELEMENT: {
    size: 'small',
  },
}

Object.keys(properties).forEach((key) => {
  app.config.globalProperties[key] = properties[key]
})

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  if (key === 'Menu')
    app.component(`${key}Icon`, component)
  else
    app.component(key, component)
}

app.use(ElementPlus)

app.use(createPinia())
app.use(router)
app.mount('#app')
app.component('Heading', Heading)
app.component('ContentLayout', ContentLayout)
app.component('OperationZone', OperationZone)
app.component('SearchBox', SearchBox)
app.component('JyTable', JyTable)
app.component('JyDrawer', JyDrawer)
app.component('SvgIcon', SvgIcon)
app.directive('autoHeight', AutoHeight)
app.directive('numberfixed', NumberFixed)
app.directive('authorize', Authorize)
app.directive('trim', TrimSpaces)

